import {cloneDeep} from 'lodash';
import {getArray, getString, resetObjectValues} from 'Core/helpers/data';
import {DynamicRecipientsDataObject} from "../dataObjects";
import * as conditionDataMap from 'DataMaps/conditions/condition';

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @param {string} templateId - Template ID.
 * @return {DynamicRecipientsDataObject}
 */
export const input = (rawData, templateId) => {
	let result = cloneDeep(rawData);

	result = new DynamicRecipientsDataObject(
		// Copy the template ID from the request into the recipients if it does not exist (new recipients will be 
		// created and it needs the template ID so we just pass the one from the request).
		(getString(result, 'messageDefinitionId') ? getString(result, 'messageDefinitionId') : templateId),
		getString(result, 'id'),
		getArray(result, 'conditions').map(i => conditionDataMap.input(i)),
		getArray(result, 'customerGroupIds').map(i => getString(i)),
	);

	return result;
}

/**
 * Get output data from input data
 * @param {DynamicRecipientsDataObject} inputData - Input data.
 * @return {Object}
 */
export const output = inputData => {
	let result = cloneDeep({
		id: inputData.id,
		messageDefinitionId: inputData.templateId,
		customerGroupIds: inputData.groups,
		conditions: inputData.conditions.map(i => conditionDataMap.output(i)),
	});
	
	// Set proper empty values expected by the API
	result = resetObjectValues(result);

	return result;
}